module.exports = __webpack_public_path__ + "static/media/hosts.ff0480d7.svg";